module.exports = __webpack_public_path__ + "public/images/avatar.1734974600528e8d6a280248c207e431.png";